import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import "./PatientDetail.css";

const PatientDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [patient, setPatient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/patients/${id}/`, {
        headers: { Authorization: `Token ${token}` },
      })
      .then((res) => {
        setPatient(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setError("Error fetching patient details");
        setLoading(false);
      });
  }, [id, token]);

  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete this patient?")) {
      axios
        .delete(`${process.env.REACT_APP_BACKEND_URL}/patients/${id}/delete/`, {
          headers: { Authorization: `Token ${token}` },
        })
        .then(() => {
          navigate("/patients");
        })
        .catch((err) => {
          alert("Error deleting patient");
        });
    }
  };

  if (loading) return <div>Loading patient details...</div>;
  if (error) return <div>{error}</div>;
  if (!patient) return <div>No patient found</div>;

  return (
    <div className="patient-detail-container">
      <h2>Patient Detail</h2>
      <div className="patient-detail">
        <p>
          <strong>ID:</strong> {patient.id}
        </p>
        <p>
          <strong>Hospital Patient ID:</strong> {patient.hospital_patient_id}
        </p>
        <p>
          <strong>Number of Study Entries:</strong>
          <Link to={`/studies?patient=${id}`}> {patient.study_count}</Link>
        </p>
        <p>
          <strong>Number of XA DICOM Entries:</strong>
          <Link to={`/dicoms?patient_id=${id}`}> {patient.dicom_count}</Link>
        </p>
        <p>
          <strong>File Path:</strong>{" "}
          <a href={patient.file_path} target="_blank" rel="noopener noreferrer">
            {patient.file_path}
          </a>
        </p>
        <p>
          <strong>Date of Birth:</strong> {patient.date_of_birth}
        </p>
        <p>
          <strong>Gender:</strong> {patient.gender}
        </p>
        <p>
          <strong>Data Source:</strong> {patient.data_source}
        </p>
        <p>
          <strong>Ethnicity:</strong> {patient.ethnicity}
        </p>
        <p>
          <strong>Diagnosis:</strong> {patient.diagnosis}
        </p>
        <p>
          <strong>Notes:</strong> {patient.notes}
        </p>
        <p>
          <strong>Original Upload Path:</strong>{" "}
          <a
            href={patient.original_upload_path}
            target="_blank"
            rel="noopener noreferrer"
          >
            {patient.original_upload_path}
          </a>
        </p>
        <p>
          <strong>Creation Time:</strong>{" "}
          {new Date(patient.creation_time).toLocaleString()}
        </p>
        <p>
          <strong>Updated Time:</strong>{" "}
          {new Date(patient.updated_time).toLocaleString()}
        </p>
        <p>
          <strong>Uploader:</strong> {patient.uploader}
        </p>
      </div>
      <div className="patient-detail-actions">
        <Link to={`/patients/${id}/edit`}>
          <button>Edit</button>
        </Link>
        <Link to={`/studies?patient=${id}`}>
          <button>View Studies</button>
        </Link>
        <Link to={`/dicoms?patient_id=${id}`}>
          <button>View DICOMs</button>
        </Link>
        <button onClick={handleDelete}>Delete</button>
      </div>
    </div>
  );
};

export default PatientDetail;
